import _ from '@lodash';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip/Tooltip';
import { setDefaultSettings } from 'app/store/fuse/settingsSlice';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { safelyParseJSON } from '../../utils/json.utils';

interface Props {
  className?: string;
}
function NavbarFoldedToggleButton(props: Props) {
  const dispatch = useDispatch();
  const settings = useSelector((state: any) => state.fuse.settings.current);
  const iconName = settings.layout.config.navbar.folded ? 'lock_open' : 'lock';
  const { t } = useTranslation();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation_todo>
  useEffect(() => {
    dispatch(
      setDefaultSettings(
        _.set({}, 'layout.config.navbar.folded', !!safelyParseJSON(localStorage.getItem('isFolded') || '')),
      ),
    );
  }, []);

  return (
    <Tooltip title={t('settings.lockSideBar') || ''} aria-label="add">
      <IconButton
        className={props.className}
        onClick={() => {
          const newFolded = !settings.layout.config.navbar.folded;
          if (newFolded) {
            localStorage.setItem('isFolded', JSON.stringify(newFolded));
          } else {
            localStorage.setItem('isFolded', JSON.stringify(newFolded));
          }
          dispatch(setDefaultSettings(_.set({}, 'layout.config.navbar.folded', newFolded)));
        }}
        color="inherit"
      >
        <Icon>{iconName}</Icon>
      </IconButton>
    </Tooltip>
  );
}

export default NavbarFoldedToggleButton;
